import z from "zod";
import { ADJUSTMENT_TYPE, DOC_CATEGORY } from "../constants";

export const schema = z
  .object({
    name: z.string().min(1, "Bid name is required"),
    builderId: z.string().min(1, "Customer is required"),
    communityId: z.string().nullable().optional(),
    bidRequestId: z.string().nullable().optional(),
    bidRequestIndex: z.number().nullable().optional(),
    bidRequest: z
      .object({
        dueDate: z.string().min(1, "Due date is required"),
        requestDate: z.string().min(1, "Request date is required"),
        requesterId: z.string().min(1, "Requester is required"),
      })
      .passthrough()
      .nullable()
      .optional(),
    assigneeId: z.string().nullable().optional(),
    seriesGroupId: z.string().nullable().optional(),
    seriesId: z.string().nullable().optional(),
    pipeBrand: z.string().optional(),
    additionalFeatures: z.string().optional(),
    requirementIds: z.array(z.string()).default([]),
    documents: z.array(
      z.object({
        category: z.string().optional(),
      })
    ),
    planAreas: z.array(
      z.object({
        floorId: z.string(),
        areaTypeId: z.string().optional(),
        label: z.string().optional(),
        specColumn: z.number().optional(),
        areaTypeName: z.string().optional(),
        displayOrder: z.number().optional(),
        materials: z
          .array(
            z.object({
              materialId: z.string(),
              suppliedByBuilder: z.boolean().optional(),
              quantity: z.number().optional(),
            })
          )
          .optional(),
      })
    ),
  })
  .refine(
    (data) => data.documents.some((d) => d.category === DOC_CATEGORY.PLAN),
    { message: "Plan file is required", path: ["documents"] }
  )
  .refine(
    (data) => data.documents.some((d) => d.category === DOC_CATEGORY.SPEC),
    { message: "Spec file is required", path: ["documents"] }
  );

export const pricingAdjustmentSchema = z.object({
  adjustments: z
    .object({
      label: z.string().min(1, "Label is required"),
      type: z.string().min(1, "Type is required"),
      amt: z.number(),
      item: z.string().optional(),
      area: z.string().optional(),
      category: z.string().optional(),
      drop: z.string().optional(),
      notes: z.string().optional(),
      maxNegativeAmount: z.number().optional(),
    })
    .superRefine((data, ctx) => {
      if (data.amt === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Amount cannot be $0",
          path: ["amt"],
        });
      }
      if (
        data.amt < 0 &&
        data.maxNegativeAmount !== undefined &&
        Math.abs(data.amt) > data.maxNegativeAmount
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Amount cannot reduce the total below $0",
          path: ["amt"],
        });
      }
    })
    .refine(
      (data) => data.type !== ADJUSTMENT_TYPE.INDIVIDUAL_ITEM || !!data.area,
      { message: "Area is required", path: ["area"] }
    )
    .refine(
      (data) => data.type !== ADJUSTMENT_TYPE.INDIVIDUAL_ITEM || !!data.item,
      { message: "Item is required", path: ["item"] }
    )
    .refine(
      (data) => data.type !== ADJUSTMENT_TYPE.INDIVIDUAL_DROP || !!data.area,
      { message: "Area is required", path: ["area"] }
    )
    .refine(
      (data) =>
        data.type !== ADJUSTMENT_TYPE.INDIVIDUAL_DROP || !!data.category,
      { message: "Category is required", path: ["category"] }
    )
    .refine(
      (data) => data.type !== ADJUSTMENT_TYPE.INDIVIDUAL_DROP || !!data.drop,
      { message: "Drop is required", path: ["drop"] }
    ),
});
